import { Cell } from "./Cell";

export class FooterCell extends Cell {
    //#region Events
    //#endregion Events

    //#region Listeners
    //#endregion Listeners

    //#region Fields
    //#endregion Fields

    //#region Properties
    //#endregion Properties

    //#region Constructors
    //#endregion Constructors

    //#region Methods
    //#endregion Methods
}
